"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Testimonials() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const testimonials = [{
    id: 1,
    quote: "Fakta Integritas membantu perusahaan kami menyelesaikan sengketa kontrak yang kompleks. Profesionalisme dan integritas tim mereka sangat luar biasa. Kami sangat merekomendasikan jasa mereka.",
    author: "Budi Hartono",
    position: "Director of PT Maju Sejahtera",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541685/img/budi_hartono_avatar.png"
  }, {
    id: 2,
    quote: "Saya sangat puas dengan layanan konsultasi hukum pertanahan dari tim Fakta Integritas. Mereka memberikan solusi yang jelas, tepat, dan selalu transparan dalam setiap proses.",
    author: "Siti Rahmawati",
    position: "Entrepreneur",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541685/img/siti_rahmawati_avatar.png"
  }, {
    id: 3,
    quote: "Terima kasih kepada tim Fakta Integritas yang telah membantu saya dalam kasus pidana. Pendampingan mereka sangat profesional dan memberikan ketenangan pikiran selama proses hukum berlangsung.",
    author: "Ahmad Fauzi",
    position: "Private Client",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541685/img/ahmad_fauzi_avatar.png"
  }, {
    id: 4,
    quote: "Penanganan kasus ketenagakerjaan oleh Fakta Integritas sangat memuaskan. Mereka memahami kompleksitas hubungan industrial dan memberikan solusi yang win-win untuk semua pihak.",
    author: "Linda Kusuma",
    position: "HR Manager",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541685/img/linda_kusuma_avatar.png"
  }, {
    id: 5,
    quote: "Saya menghargai pendekatan berbasis fakta dan integritas yang diterapkan oleh kantor hukum ini. Mereka tidak hanya fokus pada kemenangan, tapi juga pada keadilan yang sesungguhnya.",
    author: "Rudi Wijaya",
    position: "Commissioner of PT Global Investment",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541685/img/rudi_wijaya_avatar.png"
  }, {
    id: 6,
    quote: "Layanan legal audit dan drafting dokumen dari Fakta Integritas sangat membantu bisnis saya. Mereka proaktif dalam mengidentifikasi potensi masalah hukum sebelum terjadi.",
    author: "Dewi Permata",
    position: "Business Owner",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541685/img/dewi_permata_avatar.png"
  }];
  return <section id="testimonials" ref={sectionRef} className="dark bg-background text-foreground py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-16 transition-all duration-500 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-4xl font-extrabold mb-4 !text-[hsl(35,88%,47%)] md:text-5xl">Testimoni Klien Kami</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">Kepercayaan dan kepuasan klien adalah prioritas utama kami</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, i) => <Card key={testimonial.id} data-index={i} className={`bg-secondary border-transparent hover:border-primary/50 transition-all duration-300 hover:shadow-medium hover:-translate-y-1 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: sectionVisible ? `${i * 100}ms` : "0ms"
        }}>
              <CardContent className="p-6 flex flex-col gap-4">
                <div className="relative">
                  <Quote className="text-primary/30 w-16 h-16 mb-4 group-hover:scale-110 transition-transform duration-300" strokeWidth={1.5} />
                </div>

                <p className="text-foreground text-base leading-relaxed flex-grow">
                  {testimonial.quote}
                </p>

                <div className="flex items-center gap-4 mt-4 pt-4 border-t border-muted">
                  <SafeHydrate><Avatar className="w-12 h-12">
                    <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                    <AvatarFallback className="bg-primary text-foreground-primary font-semibold">
                      {testimonial.author.split(" ").map(n => n[0]).join("").toUpperCase()}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  <div>
                    <div className="font-semibold text-foreground text-lg">
                      {testimonial.author}
                    </div>
                    <div className="text-sm text-muted-foreground">
                      {testimonial.position}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}